import React from "react";
import { Box } from "@chakra-ui/react";
import type { BoxProps } from "@chakra-ui/react";

export const BasePill = React.forwardRef<HTMLDivElement, BoxProps>(
  function BasePill({ children, ...rest }, ref) {
    return (
      <Box
        ref={ref}
        border="1px solid"
        borderColor="gray.200"
        borderRadius="8px"
        px="10px"
        py="6px"
        display="inline-flex"
        cursor="pointer"
        _hover={{ borderColor: "gray.400", bg: "gray.50" }}
        transition="all 0.12s"
        {...rest}
      >
        {children}
      </Box>
    );
  }
);
